var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7078 17.2929C13.0984 17.6834 13.0984 18.3166 12.7078 18.7071C12.3173 19.0976 11.6842 19.0976 11.2936 18.7071L5.29364 12.7071C4.91506 12.3285 4.90181 11.7189 5.26359 11.3243L10.7636 5.32428C11.1368 4.91716 11.7693 4.88966 12.1765 5.26285C12.5836 5.63604 12.6111 6.26861 12.2379 6.67573L7.38488 11.9699L12.7078 17.2929Z",
    fill: "#6993FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.7077 17.2929C20.0982 17.6834 20.0982 18.3166 19.7077 18.7071C19.3172 19.0976 18.684 19.0976 18.2935 18.7071L12.2935 12.7071C11.9149 12.3285 11.9017 11.7189 12.2635 11.3243L17.7635 5.32428C18.1367 4.91716 18.7692 4.88966 19.1763 5.26285C19.5835 5.63604 19.611 6.26861 19.2378 6.67573L14.3848 11.9699L19.7077 17.2929Z",
    fill: "#6993FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.22e17f0764cfa1d024e7cb54fa44cbc0.svg";
export { ForwardRef as ReactComponent };